import { Buttons, useResize } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import { showChat } from 'Services/chat';
import { history } from 'Store';
import useTranslation from 'Hooks/useTranslation';
import { PreviousYearStatus } from 'Containers/PreviousYears/types';
import {
  handleRedirectUser,
  isReadyAndNotZero,
  needEfirma,
} from 'Containers/Dashboard/components/PreviousYearBanner/utils';
import { routes } from 'Constants/routes';
import { BannerButtonsProps } from './types';

const EFIRMA_CONTEXT = 'efirma';
const CONTINUE_CONTEXT = 'continue';
const REQUEST_CONTEXT = 'request';

const ButtonsBanner = ({ data, satUserData, isRequest }: BannerButtonsProps): JSX.Element => {
  const { t } = useTranslation(locizeNS.PY);
  const { isMobile } = useResize();
  const isSubmitted = data?.stage === PreviousYearStatus.SUBMITTED;
  const isEfirma = needEfirma(satUserData, isRequest?.isRequested, data);
  const buttonSize = isMobile ? 'xs' : 's';

  const handleClickUserSubmitted = (): void => {
    if (isEfirma) {
      history.push(routes.PREVIOUS_YEARS_WORKING, {
        isDashboardUser: true,
      });
    } else {
      showChat();
    }
  };

  const buttonContext = satUserData?.efirmaIsValid
    ? CONTINUE_CONTEXT
    : isEfirma
      ? EFIRMA_CONTEXT
      : REQUEST_CONTEXT;
  return (
    <>
      {data && isReadyAndNotZero(data) && (
        <Buttons.Classic
          mode="primary"
          label={t('PreviousYearBanner.button', {
            context: buttonContext,
          })}
          size={buttonSize}
          onClick={() => handleRedirectUser(data, isRequest)}
        />
      )}
      {(isEfirma || isSubmitted) && (
        <Buttons.Classic
          mode="primary"
          label={t('PreviousYearBanner.button', {
            context: isSubmitted && !isEfirma ? 'submitted' : 'efirma',
          })}
          size={buttonSize}
          onClick={handleClickUserSubmitted}
        />
      )}
      {(!data || !isRequest) && (
        <Buttons.Classic
          mode="cold"
          label={t('PreviousYearBanner.button')}
          size={buttonSize}
          onClick={() => handleRedirectUser(data, isRequest)}
        />
      )}
    </>
  );
};

export default ButtonsBanner;
